export const records = ($http: HttpApi) => ({
  get: (recordId: string, params: HttpParams['params'] = {}) => $http.$get(`/records/${recordId}`, { params }),
});
